import { __decorate } from "tslib";
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
const GlobalStore = namespace('GlobalStore');
let AuthMixin = class AuthMixin extends Vue {
    mutationLoginUser;
    mutationUnLoginUser;
    setUser(user) {
        this.mutationLoginUser(user);
    }
    doUnLoginUser() {
        this.mutationUnLoginUser();
    }
    unLoginUserAndRedirect() {
        this.mutationUnLoginUser();
        window.location.href = '/';
    }
};
__decorate([
    GlobalStore.Mutation('mutationLoginUser')
], AuthMixin.prototype, "mutationLoginUser", void 0);
__decorate([
    GlobalStore.Mutation('mutationUnLoginUser')
], AuthMixin.prototype, "mutationUnLoginUser", void 0);
AuthMixin = __decorate([
    Component
], AuthMixin);
export default AuthMixin;
;
